module.exports = __webpack_public_path__ + "static/media/thumbnail_advincula-soft-cup@2x.7958f55c.jpg";